import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';

/**
 * Decides whether the BVS simulation runs on this PDP and loads its manifest.
 */
export function useBvsPdpSimulation() {
  const store = useProductDetailPageStore();
  const { $globalPageSettings, $activeLocale } = useNuxtApp();

  const isFeatureEnabled = computed(() => {
    const featureToggles = buildFeatureToggles($globalPageSettings.value);
    const enabledLocales = featureToggles?.showBvsImageRendering ?? [];
    return enabledLocales.includes($activeLocale.value.webapp);
  });

  const sku = computed(() =>
    isFeatureEnabled.value && store.decoratedProduct?.cameraCategory
      ? (store.decoratedProduct.sku ?? '')
      : ''
  );

  const { manifest, isLoading, isAvailable } = useBvsCameraManifest(sku);

  return { sku, manifest, isLoading, isAvailable };
}
